import { CaretUp } from 'phosphor-react';

function NoticeCenter({
  activeNotice,
  noticeFeed,
  isNoticeListOpen,
  setIsNoticeListOpen,
  setActiveNoticeKey,
  setExpandedNotice
}) {
  if (!activeNotice) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[80] w-[min(92vw,420px)]">
      {noticeFeed.length > 1 && (
        <div
          className={`mb-2 overflow-auto rounded-xl border border-slate-200 bg-white/95 p-2 shadow-lg backdrop-blur transition-all duration-200 ${
            isNoticeListOpen
              ? 'max-h-72 translate-y-0 opacity-100'
              : 'pointer-events-none max-h-0 -translate-y-1 p-0 opacity-0'
          }`}
        >
          {noticeFeed.map((entry) => (
            <button
              key={entry.key}
              type="button"
              onClick={() => {
                setActiveNoticeKey(entry.key);
                setIsNoticeListOpen(false);
              }}
              className={`block w-full rounded-lg px-2 py-2 text-left text-xs transition ${
                entry.key === activeNotice.key
                  ? entry.tone === 'error'
                    ? 'bg-red-100 text-red-800'
                    : 'bg-slate-100 text-slate-900'
                  : entry.tone === 'error'
                    ? 'text-red-700 hover:bg-red-50'
                    : 'text-slate-700 hover:bg-slate-100'
              }`}
            >
              <p className="truncate font-semibold">{entry.title}</p>
              <p className="truncate">{entry.message}</p>
            </button>
          ))}
        </div>
      )}
      <div
        className={`relative rounded-xl border px-3 py-3 pr-12 text-sm shadow-lg backdrop-blur ${
          activeNotice.tone === 'error'
            ? 'border-red-200 bg-red-50/95 text-red-700'
            : activeNotice.tone === 'success'
              ? 'border-emerald-200 bg-emerald-50/95 text-emerald-700'
              : 'border-brand-600 bg-brand-500/95 text-white'
        }`}
      >
        <button
          type="button"
          className="block min-w-0 w-full text-left"
          onClick={() => setExpandedNotice(activeNotice)}
          aria-label="Open full message"
          title="Open full message"
        >
          <p className="truncate text-xs font-semibold">{activeNotice.title}</p>
          <p className="truncate text-sm">{activeNotice.message}</p>
        </button>
        {noticeFeed.length > 1 && (
          <button
            type="button"
            className="absolute right-3 top-1/2 inline-flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition"
            onClick={() => setIsNoticeListOpen((prev) => !prev)}
            aria-label={isNoticeListOpen ? 'Hide message list' : 'Show message list'}
            title={isNoticeListOpen ? 'Hide message list' : 'Show message list'}
          >
            <CaretUp size={14} weight="bold" className={`transition-transform duration-200 ${isNoticeListOpen ? 'rotate-180' : ''}`} />
          </button>
        )}
      </div>
    </div>
  );
}

export default NoticeCenter;
